import { Component, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Input } from 'src/app/models/tyres';
import { SlowMovingStockService } from './slow-moving-stock.service';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SlowStock } from 'src/app/models/slow-moving-stock';

//TODO:
//Search bar centered: empty div
//check invisible


@Component({
  selector: 'app-slow-moving-stock',
  templateUrl: './slow-moving-stock.component.html',
  styleUrls: ['./slow-moving-stock.component.less'],
})
export class SlowMovingStockComponent {

  isLoadingStock = false
  isAddStock = false
  isUpdateStock = false

  title = ''
  errorMsg = ''

  successCheck = false

  stock: SlowStock[]=[];
  descriptionOptions: string[]=[];

  spanInput = 12;
  spanButton = 8;
  spanStock = 24;

  pageSize=20

  input = new Input()

  stockForm: FormGroup
  private destroy$ = new Subject<void>();

  constructor(private fb: FormBuilder, private slowStockService: SlowMovingStockService) {
    this.stockForm = this.fb.group({
      description: ['', [Validators.required]],
      price: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      soh: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      stockId: [null]
    });
  }
  
  ngOnInit() {
    this.input.inputValue = ''
    this.getItems()

    this.stockForm.get('description')!.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value => this.slowStockService.search(value || '')),
      takeUntil(this.destroy$)
    )
    .subscribe((results: any) => {
      this.descriptionOptions = [...results]
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  } 

  
  @HostListener("window:scroll", [])
    onScroll(): void {
    if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight - (document.body.scrollHeight * 0.1)) {
            this.pageSize += 10;
            this.input.inputValue = this.input.inputValue;
        }
    }

  resetTable(){
      this.pageSize = 20;
  }

  closeModal(form: FormGroup){
    this.isAddStock = false
    this.isUpdateStock = false
    form.reset();
  }
  
  openAdd() {
    this.isAddStock = true
    this.title = 'Add new Item'

    this.resetTable()

    this.stockForm.get('description')?.enable();
  }

  loadStock(data: SlowStock) {
    this.isUpdateStock = true;
    this.title = 'Update Item'

    this.stockForm.patchValue(JSON.parse(JSON.stringify(data)))

    this.stockForm.get('description')?.disable();
  }

  removeItem(data: SlowStock) {
    
      this.slowStockService.removeSlowStock(data.stockId).subscribe((res: any) => {
        this.stock = this.stock.filter((i) => i.stockId !== data.stockId)
      },
      err => {
         console.error('Failed to remove slow stock item.', err.error.detail)

         this.errorMsg = err.error.detail
      }
    )
  }

  addItem() {

    const stock = new SlowStock()
    stock.price = this.stockForm.value.price
    stock.soh = this.stockForm.value.soh
    stock.description = this.stockForm.value.description

    this.slowStockService.createSlowStock(stock).subscribe((res: any) => {

      this.isAddStock = false
      this.getItems()
      
    },
    err => {
         console.error('Failed to add slow stock item.', err.error.detail)

         this.errorMsg = err.error.detail
         this.isAddStock = false
        }
      )
  }
  
  updateItem() {
    const stock = new SlowStock()
    stock.stockId = this.stockForm.value.stockId
    stock.price = this.stockForm.value.price
    stock.soh = this.stockForm.value.soh
    stock.code = this.stockForm.value.code

    this.slowStockService.updateSlowStock(stock).subscribe((res: any) => {

      this.isUpdateStock = false
      this.getItems()
      

      },
      err => {
         console.error('Failed to update slow stock item.', err.error.detail)

         this.errorMsg = err.error.detail
         this.isUpdateStock = false
      }
    )
  }

  getItems() {
        this.slowStockService.getSlowStock(this.input.inputValue).subscribe((res: any) => {
          const items = res.map((i: any) => JSON.parse(JSON.stringify(i)))

          this.stock = [...items] 
      },
      err => {
         console.error('Failed to retrieve list of slow stock items.', err.error.detail)

         this.errorMsg = err.error.detail
      }
    )
  }
  
  submit() {
    if(this.isAddStock) {
      this.addItem()
    }

    else if (this.isUpdateStock) {
      this.updateItem()
    }
  }
}
